<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I want to thank Austin Macauley and everybody who contributed to making this book what it is now. By doing this they have helped turn my dream into reality. I also want to thank you, the reader, for purchasing this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?9de9c530